import React from "react";
import classnames from "classnames";
import find from "lodash/find";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import PurchaseType from "./purchase-type";
import ProDescription from "./pro-download-description";

class SelectPurchaseType extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (
            this.props.user &&
            !this.props.user.is_anonymous &&
            this.props.user.has_credit_card
        ) {
            this.props.stripeGetSavedCard();
        }
    }

    canContinue() {
        return !!this.props.currentPurchase;
    }

    render() {
        let { currentPurchase, purchaseTypes, stripeError } = this.props;

        let paymentOptions = purchaseTypes.map(purchaseType => {
            if (purchaseType.hide) {
                return;
            }
            return (
                <PurchaseType
                    key={purchaseType.key}
                    purchaseType={purchaseType}
                    currentPurchase={currentPurchase}
                    onClick={this.props.downloadSelectPurchaseType.bind(
                        null,
                        purchaseType.key
                    )}
                />
            );
        });

        let buttonClass = classnames("button", {
            lightgray: !this.canContinue(),
            blue: this.canContinue()
        });

        let formClass = classnames("billing-form", {
            "with-purchase-selected": !!currentPurchase
        });

        let onContinue = this.canContinue()
            ? this.props.downloadCommitPurchaseType
            : null;

        let error;
        if (stripeError) {
            error = <div className="error stripe-error">{stripeError}</div>;
        }
        return (
            <React.Fragment>
                <ProDescription />
                <div className={formClass}>
                    <ul className="purchase-types bubble-choices blue-choices">
                        {paymentOptions}
                    </ul>
                    <button className={buttonClass} onClick={onContinue}>
                        Select Payment
                    </button>
                    {error}
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let { stripe, download, user } = state;

    let { purchaseTypes, currentPurchaseKey, error } = stripe;

    let currentPurchase = find(purchaseTypes, { key: currentPurchaseKey });

    return {
        purchaseTypes,
        currentPurchase,
        user,
        stripeError: error
    };
}

export default connect(
    mapStateToProps,
    {
        downloadSelectPurchaseType: actions.downloadSelectPurchaseType,
        downloadCommitPurchaseType: actions.downloadCommitPurchaseType,
        stripeGetSavedCard: actions.stripeGetSavedCard
    }
)(SelectPurchaseType);
